import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bee949ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "main-tabs"
}
const _hoisted_2 = {
  key: 1,
  class: "main-tabs dragon-main-tabs"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dragon-popover-content" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "dragon-popover-title" }, "龙头冲刺"),
  /*#__PURE__*/_createElementVNode("p", { class: "dragon-popover-desc" }, "该信号指具备板块效应，呈现强势态势的龙头股。"),
  /*#__PURE__*/_createElementVNode("p", {
    class: "dragon-popover-title",
    style: {"margin-top":"12px"}
  }, "龙头点火"),
  /*#__PURE__*/_createElementVNode("p", { class: "dragon-popover-desc" }, "该信号指具备板块热度扩散，有晋级潜力的龙头股。")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dragon-info-icon commonquestion" }, null, -1))
const _hoisted_5 = {
  key: 2,
  class: "main-tabs"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dragon-popover-content" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "dragon-popover-title" }, "龙头启动"),
  /*#__PURE__*/_createElementVNode("p", { class: "dragon-popover-desc" }, "是指具备板块效应，自上而下寻找龙头股。"),
  /*#__PURE__*/_createElementVNode("p", {
    class: "dragon-popover-title",
    style: {"margin-top":"12px"}
  }, "龙头加强"),
  /*#__PURE__*/_createElementVNode("p", { class: "dragon-popover-desc" }, "在龙头启动的基础上，筛选走势更强势的龙头股。"),
  /*#__PURE__*/_createElementVNode("p", {
    class: "dragon-popover-title",
    style: {"margin-top":"12px"}
  }, "后排超车"),
  /*#__PURE__*/_createElementVNode("p", { class: "dragon-popover-desc" }, "后排超车是指板块热度扩散，有后排晋级潜力的个股。"),
  /*#__PURE__*/_createElementVNode("p", {
    class: "dragon-popover-title",
    style: {"margin-top":"12px"}
  }, "二波左侧"),
  /*#__PURE__*/_createElementVNode("p", { class: "dragon-popover-desc" }, "指前期强势，回档至重要均线支撑，止跌信号、资金与技术共振的个股。"),
  /*#__PURE__*/_createElementVNode("p", {
    class: "dragon-popover-title",
    style: {"margin-top":"12px"}
  }, "二波右侧"),
  /*#__PURE__*/_createElementVNode("p", { class: "dragon-popover-desc" }, "指前期强势，回档至重要均线支撑，再次强势启动的个股。")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dragon-info-icon commonquestion" }, null, -1))
const _hoisted_8 = { class: "filter-header" }
const _hoisted_9 = { class: "left-section" }
const _hoisted_10 = {
  key: 0,
  class: "signal-tabs"
}
const _hoisted_11 = {
  key: 1,
  class: "signal-tabs"
}
const _hoisted_12 = {
  key: 2,
  class: "update-time"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "更新时间：", -1))
const _hoisted_14 = { class: "time-text" }
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 3,
  class: "dragon-hunter-before-actions"
}
const _hoisted_17 = {
  key: 4,
  class: "update-time"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "更新时间：", -1))
const _hoisted_19 = { class: "time-text" }
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 0,
  class: "stock-count-inline"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stock-count-label" }, "股票数量：", -1))
const _hoisted_23 = { class: "stock-count-value" }
const _hoisted_24 = {
  key: 5,
  class: "update-time"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "更新时间：", -1))
const _hoisted_26 = { class: "time-text" }
const _hoisted_27 = ["src"]
const _hoisted_28 = {
  key: 0,
  class: "stock-count-inline"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stock-count-label" }, "股票数量：", -1))
const _hoisted_30 = { class: "stock-count-value" }
const _hoisted_31 = {
  key: 6,
  class: "history-date-select"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "选择日期：", -1))
const _hoisted_33 = {
  key: 0,
  class: "stock-count-inline"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stock-count-label" }, "股票数量：", -1))
const _hoisted_35 = { class: "stock-count-value" }
const _hoisted_36 = { class: "actions" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" 只看自选 ")
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" 只看自选 ")
const _hoisted_39 = {
  class: "stock-search-wrapper",
  style: {"margin-left":"12px"}
}
const _hoisted_40 = {
  key: 0,
  class: "dragon-hunter-selected-stock"
}
const _hoisted_41 = { class: "selected-stock-text" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "option-code" }
const _hoisted_44 = {
  class: "option-name",
  style: {"margin-left":"8px"}
}
const _hoisted_45 = ["onClick"]
const _hoisted_46 = {
  key: 2,
  class: "stock-search-wrapper"
}
const _hoisted_47 = /*#__PURE__*/_createTextVNode("> ")
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "stock-code" }
const _hoisted_50 = ["title"]
const _hoisted_51 = { class: "stock-market" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { class: "filter-content-popup" }
const _hoisted_54 = { class: "filter-scroll-area" }
const _hoisted_55 = { class: "filter-group" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filter-label" }, "趋势势能", -1))
const _hoisted_57 = { class: "filter-options" }
const _hoisted_58 = { class: "filter-group" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filter-label" }, "资金标尺", -1))
const _hoisted_60 = { class: "filter-options" }
const _hoisted_61 = { class: "filter-group" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filter-label" }, "题材追踪", -1))
const _hoisted_63 = { class: "filter-options" }
const _hoisted_64 = { class: "filter-actions" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "↻", -1))
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" 恢复默认 ")
const _hoisted_67 = /*#__PURE__*/_createTextVNode(" 确定 ")
const _hoisted_68 = ["src"]
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" 筛选 ")
const _hoisted_70 = {
  key: 3,
  class: "selected-stock-info"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "入选股票：", -1))
const _hoisted_72 = { class: "info-count" }
const _hoisted_73 = { class: "info-desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["filter-panel", _ctx.theme])
  }, [
    (_ctx.isMengzhuTrend && _ctx.mainTabs)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", {
            class: _normalizeClass(['main-tab', { active: _ctx.currentMainTab === 'signalPool' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleMainTabChange('signalPool')))
          }, _toDisplayString(_ctx.mainTabs.signalPool?.label || '信号池'), 3),
          _createElementVNode("span", {
            class: _normalizeClass(['main-tab', { active: _ctx.currentMainTab === 'hotCases' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleMainTabChange('hotCases')))
          }, _toDisplayString(_ctx.mainTabs.hotCases?.label || '近30天热门案例'), 3)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isDragonSignal && _ctx.mainTabs)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", {
            class: _normalizeClass(['main-tab', { active: _ctx.currentMainTab === 'dragon_signal_sprint' }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleMainTabChange('dragon_signal_sprint')))
          }, _toDisplayString(_ctx.mainTabs.signalPool?.label || '龙头冲刺'), 3),
          _createElementVNode("span", {
            class: _normalizeClass(['main-tab', { active: _ctx.currentMainTab === 'dragon_signal_ignition' }]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleMainTabChange('dragon_signal_ignition')))
          }, _toDisplayString(_ctx.mainTabs.hotCases?.label || '龙头点火'), 3),
          _createVNode(_component_a_popover, {
            placement: "bottomLeft",
            overlayClassName: "dragon-info-popover",
            getPopupContainer: _ctx.getPopupContainer
          }, {
            content: _withCtx(() => [
              _hoisted_3
            ]),
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["getPopupContainer"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isDragonHunter)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("span", {
            class: _normalizeClass(['main-tab', { active: _ctx.dragonHunterMainTab === 'newChose' }]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleMainTabChange('newChose')))
          }, "最新入选", 2),
          _createElementVNode("span", {
            class: _normalizeClass(['main-tab', { active: _ctx.dragonHunterMainTab === 'dataTrack' }]),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleMainTabChange('dataTrack')))
          }, "数据追踪", 2),
          _createElementVNode("span", {
            class: _normalizeClass(['main-tab', { active: _ctx.dragonHunterMainTab === 'hotCase' }]),
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleMainTabChange('hotCase')))
          }, "热门案例", 2),
          _createElementVNode("span", {
            class: _normalizeClass(['main-tab', { active: _ctx.dragonHunterMainTab === 'beforeChose' }]),
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleMainTabChange('beforeChose')))
          }, "查看往期", 2),
          _createVNode(_component_a_popover, {
            placement: "bottomLeft",
            overlayClassName: "dragon-info-popover",
            getPopupContainer: _ctx.getPopupContainer
          }, {
            content: _withCtx(() => [
              _hoisted_6
            ]),
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["getPopupContainer"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        (!_ctx.isDragonHunter && (!_ctx.isMengzhuTrend || _ctx.currentMainTab === 'signalPool'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("span", {
                class: _normalizeClass(['tab', { active: _ctx.signalType === 'latest' }]),
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleSignalTypeChange('latest')))
              }, _toDisplayString(_ctx.signalTabLabels.latest), 3),
              _createElementVNode("span", {
                class: _normalizeClass(['tab', { active: _ctx.signalType === 'history' }]),
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleSignalTypeChange('history')))
              }, _toDisplayString(_ctx.signalTabLabels.history), 3),
              (_ctx.isDragonSignal)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(['tab', { active: _ctx.signalType === 'backtest' }]),
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleSignalTypeChange('backtest')))
                  }, " 回测数据跟踪 ", 2))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isDragonHunter && (_ctx.dragonHunterMainTab === 'newChose' || _ctx.dragonHunterMainTab === 'dataTrack'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("span", {
                class: _normalizeClass(['tab', { active: _ctx.dragonHunterSubTab === 'dragonStar' }]),
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleDragonHunterSubTabChange('dragonStar')))
              }, "龙头启动", 2),
              _createElementVNode("span", {
                class: _normalizeClass(['tab', { active: _ctx.dragonHunterSubTab === 'dragonDouble' }]),
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleDragonHunterSubTabChange('dragonDouble')))
              }, "龙头加强", 2),
              _createElementVNode("span", {
                class: _normalizeClass(['tab', { active: _ctx.dragonHunterSubTab === 'overTaking' }]),
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleDragonHunterSubTabChange('overTaking')))
              }, "后排超车", 2),
              _createElementVNode("span", {
                class: _normalizeClass(['tab', { active: _ctx.dragonHunterSubTab === 'dragonLeft' }]),
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleDragonHunterSubTabChange('dragonLeft')))
              }, "二波左侧", 2),
              _createElementVNode("span", {
                class: _normalizeClass(['tab', { active: _ctx.dragonHunterSubTab === 'dragonRight' }]),
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleDragonHunterSubTabChange('dragonRight')))
              }, "二波右侧", 2)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isDragonHunter && _ctx.dragonHunterMainTab === 'newChose')
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.updateTime || '--'), 1),
              _createElementVNode("span", {
                class: "refresh-icon",
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.handleRefresh && _ctx.handleRefresh(...args)))
              }, [
                _createElementVNode("img", {
                  src: require('@/assets/Refresh.png'),
                  alt: "刷新"
                }, null, 8, _hoisted_15)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isDragonHunter && _ctx.dragonHunterMainTab === 'beforeChose')
          ? (_openBlock(), _createElementBlock("div", _hoisted_16))
          : _createCommentVNode("", true),
        (!_ctx.isDragonHunter && _ctx.signalType === 'latest' && (!_ctx.isMengzhuTrend || _ctx.currentMainTab === 'signalPool'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.updateTime || '--'), 1),
              _createElementVNode("span", {
                class: "refresh-icon",
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.handleRefresh && _ctx.handleRefresh(...args)))
              }, [
                _createElementVNode("img", {
                  src: require('@/assets/Refresh.png'),
                  alt: "刷新"
                }, null, 8, _hoisted_20)
              ]),
              (_ctx.showStockCount)
                ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.stockCount), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (!_ctx.isDragonHunter && !_ctx.showHistoryDateSelect && (!_ctx.isMengzhuTrend || _ctx.currentMainTab === 'signalPool'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.updateTime || '--'), 1),
                _createElementVNode("span", {
                  class: "refresh-icon",
                  onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.handleRefresh && _ctx.handleRefresh(...args)))
                }, [
                  _createElementVNode("img", {
                    src: require('@/assets/Refresh.png'),
                    alt: "刷新"
                  }, null, 8, _hoisted_27)
                ]),
                (_ctx.showStockCount)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.stockCount), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (!_ctx.isDragonHunter && (!_ctx.isMengzhuTrend || _ctx.currentMainTab === 'signalPool') && _ctx.signalType !== 'backtest')
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _hoisted_32,
                  _createVNode(_component_a_select, {
                    value: _ctx.selectedDate,
                    "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.selectedDate) = $event)),
                    style: {"width":"160px"},
                    placeholder: "请选择日期",
                    onChange: _ctx.onHistoryDateSelect,
                    dropdownClassName: _ctx.theme === 'dark' ? 'dark-dropdown' : 'light-dropdown'
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateOptions, (date) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: date,
                          value: date
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(date), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value", "onChange", "dropdownClassName"]),
                  (_ctx.showStockCount)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                        _hoisted_34,
                        _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.stockCount), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_36, [
        ((!_ctx.isMengzhuTrend || _ctx.currentMainTab === 'signalPool') && _ctx.signalType !== 'backtest' && !_ctx.isDragonHunter)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(['only-optional', { active: _ctx.onlyOptional }]),
              onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.toggleOptional && _ctx.toggleOptional(...args)))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(['checkbox-icon', { active: _ctx.onlyOptional }])
              }, null, 2),
              _hoisted_37
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.isDragonHunter && _ctx.dragonHunterMainTab === 'beforeChose')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("span", {
                class: _normalizeClass(['only-optional', { active: _ctx.dragonHunterOnlyOptional }]),
                onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.toggleDragonHunterOptional && _ctx.toggleDragonHunterOptional(...args)))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(['checkbox-icon', { active: _ctx.dragonHunterOnlyOptional }])
                }, null, 2),
                _hoisted_38
              ], 2),
              _createElementVNode("div", _hoisted_39, [
                (_ctx.dragonHunterDisplayValue)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.dragonHunterDisplayValue), 1),
                      _createElementVNode("span", {
                        class: "selected-stock-clear",
                        onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.handleDragonHunterClear && _ctx.handleDragonHunterClear(...args)))
                      }, "×")
                    ]))
                  : (_openBlock(), _createBlock(_component_a_select, {
                      key: 1,
                      ref: "dragonHunterSearchRef",
                      value: _ctx.dragonHunterSearchValue,
                      "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.dragonHunterSearchValue) = $event)),
                      "show-search": "",
                      placeholder: "搜索个股",
                      style: {"width":"160px"},
                      "show-arrow": false,
                      "filter-option": false,
                      getPopupContainer: _ctx.getPopupContainer,
                      "not-found-content": null,
                      open: _ctx.dragonHunterDropdownOpen,
                      onSearch: _ctx.handleDragonHunterSearch,
                      onFocus: _ctx.handleDragonHunterFocus,
                      onBlur: _ctx.handleDragonHunterBlur,
                      onSelect: _ctx.handleDragonHunterSelect,
                      dropdownClassName: (_ctx.theme === 'dark' ? 'dark-dropdown' : 'light-dropdown') + ' dragon-hunter-dropdown'
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dragonHunterDisplayOptions, (item) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            value: item.Id || item.Code,
                            key: item.Id || item.Code
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: "dragon-hunter-option-item",
                                onClick: _withModifiers(($event: any) => (_ctx.handleDragonHunterStockClick(item)), ["stop"])
                              }, [
                                _createElementVNode("span", _hoisted_43, _toDisplayString(item.Code), 1),
                                _createElementVNode("span", _hoisted_44, _toDisplayString(item.Name), 1),
                                (_ctx.dragonHunterIsShowingHistory)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: "option-delete",
                                      onClick: _withModifiers(($event: any) => (_ctx.removeFromDragonHunterHistory(item, $event)), ["stop"])
                                    }, "×", 8, _hoisted_45))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_42)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value", "getPopupContainer", "open", "onSearch", "onFocus", "onBlur", "onSelect", "dropdownClassName"]))
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.showStockSearch)
          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
              _createVNode(_component_a_select, {
                ref: "stockSearchRef",
                value: _ctx.searchStock,
                "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.searchStock) = $event)),
                "show-search": "",
                placeholder: '搜索个股筹码大师',
                style: {"width":"200px"},
                "show-arrow": false,
                "filter-option": false,
                getPopupContainer: _ctx.getPopupContainer,
                "not-found-content": null,
                open: _ctx.searchDropdownOpen,
                onSearch: _ctx.handleStockSearch,
                onFocus: _ctx.handleSearchFocus,
                onBlur: _ctx.handleSearchBlur,
                onDropdownVisibleChange: _ctx.handleDropdownVisibleChange,
                onSelect: _ctx.handleOptionSelect,
                listHeight: 300,
                virtual: false,
                dropdownClassName: _ctx.theme === 'dark' ? 'dark-dropdown' : 'light-dropdown'
              }, {
                default: _withCtx(() => [
                  _hoisted_47,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: item.Id,
                      key: item.Id
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "stock-option-item",
                          onClick: _withModifiers(($event: any) => (_ctx.handleStockSelect(item)), ["stop"])
                        }, [
                          _createElementVNode("span", _hoisted_49, _toDisplayString(item.Code), 1),
                          _createElementVNode("span", {
                            class: "stock-name",
                            title: item.Name
                          }, _toDisplayString(_ctx.formatStockName(item.Name)), 9, _hoisted_50),
                          _createElementVNode("span", _hoisted_51, _toDisplayString(item.MarketCode === 'sh' ? '沪A' : item.MarketCode === 'sz' ? '深A' :
                  item.MarketCode === 'bj' ? '京A' : ''), 1),
                          (_ctx.isShowingHistory)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "history-delete-icon",
                                onClick: _withModifiers(($event: any) => (_ctx.removeFromHistory(item, $event)), ["stop"])
                              }, "×", 8, _hoisted_52))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_48)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "getPopupContainer", "open", "onSearch", "onFocus", "onBlur", "onDropdownVisibleChange", "onSelect", "dropdownClassName"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showFilterBtn)
          ? (_openBlock(), _createBlock(_component_a_popover, {
              key: 3,
              visible: _ctx.showFilter,
              placement: "bottomRight",
              overlayClassName: "filter-popover",
              getPopupContainer: _ctx.getPopupContainer
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _hoisted_56,
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("span", {
                          class: _normalizeClass(['option', { active: _ctx.filters.macd === 0 }]),
                          onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.setFilter('macd', 0)))
                        }, "全部", 2),
                        _createElementVNode("span", {
                          class: _normalizeClass(['option', { active: _ctx.filters.macd === 1 }]),
                          onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.setFilter('macd', 1)))
                        }, "强势", 2),
                        _createElementVNode("span", {
                          class: _normalizeClass(['option', { active: _ctx.filters.macd === 2 }]),
                          onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.setFilter('macd', 2)))
                        }, "弱势", 2)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _hoisted_59,
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("span", {
                          class: _normalizeClass(['option', { active: _ctx.filters.amount === 0 }]),
                          onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.setFilter('amount', 0)))
                        }, "全部", 2),
                        _createElementVNode("span", {
                          class: _normalizeClass(['option', { active: _ctx.filters.amount === 1 }]),
                          onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.setFilter('amount', 1)))
                        }, "强势", 2),
                        _createElementVNode("span", {
                          class: _normalizeClass(['option', { active: _ctx.filters.amount === 2 }]),
                          onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.setFilter('amount', 2)))
                        }, "弱势", 2)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                      _hoisted_62,
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("span", {
                          class: _normalizeClass(['option', { active: _ctx.filters.plate === 0 }]),
                          onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.setFilter('plate', 0)))
                        }, "全部", 2),
                        _createElementVNode("span", {
                          class: _normalizeClass(['option', { active: _ctx.filters.plate === 1 }]),
                          onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.setFilter('plate', 1)))
                        }, "核心风口", 2),
                        _createElementVNode("span", {
                          class: _normalizeClass(['option', { active: _ctx.filters.plate === 2 }]),
                          onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.setFilter('plate', 2)))
                        }, "普通风口", 2),
                        _createElementVNode("span", {
                          class: _normalizeClass(['option', { active: _ctx.filters.plate === 3 }]),
                          onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.setFilter('plate', 3)))
                        }, "未入选", 2)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_64, [
                    _createVNode(_component_a_button, {
                      class: "reset-btn",
                      onClick: _ctx.handleReset
                    }, {
                      default: _withCtx(() => [
                        _hoisted_65,
                        _hoisted_66
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      class: "confirm-btn",
                      onClick: _ctx.handleConfirm
                    }, {
                      default: _withCtx(() => [
                        _hoisted_67
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", {
                  class: _normalizeClass(['filter-btn', { active: _ctx.isFilterActive }]),
                  onClick: _cache[35] || (_cache[35] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleFilter && _ctx.toggleFilter(...args)), ["stop"]))
                }, [
                  _createElementVNode("img", {
                    src: _ctx.getFilterIcon(),
                    alt: "筛选",
                    class: "filter-icon"
                  }, null, 8, _hoisted_68),
                  _hoisted_69
                ], 2)
              ]),
              _: 1
            }, 8, ["visible", "getPopupContainer"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.showSelectedStockInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
          _hoisted_71,
          _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.selectedStockCount), 1),
          _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.selectedStockDescription), 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}